function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MalaysiaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2330",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2330)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V21H0V3Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0.0203857",
      y: "6.75",
      width: "24",
      height: "2.175",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0.0203857",
      y: "10.65",
      width: "24",
      height: "2.175",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0.0837402",
      y: "14.4",
      width: "24",
      height: "1.875",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0.0837402",
      y: "18.15",
      width: "24",
      height: "2.025",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V4.875H0V3Z",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H12V12H0V3Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.69519 7.65165C2.69519 8.68382 3.18136 9.65988 4.17042 9.65988C5.65436 9.65988 5.94305 9.34351 6.63549 8.90703C6.7992 9.27473 6.24701 10.8483 4.15017 10.8483C2.47298 10.8145 1.11755 9.46714 1.11755 7.65165C1.11755 5.56776 2.65024 4.44235 4.10808 4.45509C5.3951 4.45509 6.76012 5.18541 6.71829 6.11708C6.11188 5.5247 5.45342 5.5247 4.35731 5.5247C3.26119 5.5247 2.69519 6.61935 2.69519 7.65165Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.25 8.47501L7.55471 9.48988L7.58874 8.26015L6.42971 8.67252L7.18006 7.69765L6 7.35001L7.18006 7.00236L6.42971 6.02749L7.58874 6.43986L7.55471 5.21013L8.25 6.22501L8.94529 5.21013L8.91126 6.43986L10.0703 6.02749L9.31994 7.00236L10.5 7.35001L9.31994 7.69765L10.0703 8.67252L8.91126 8.26015L8.94529 9.48988L8.25 8.47501Z",
      fill: "#FECA00"
    })]
  })]
}));
//# sourceMappingURL=Malaysia.js.map